import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withModifiers as _withModifiers, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, unref as _unref } from "vue"

const _hoisted_1 = { class: "crm:inline-block" }
const _hoisted_2 = { class: "crm:text-zinc-500 crm:px-2" }
const _hoisted_3 = {
  key: 0,
  class: "crm:grid crm:grid-cols-6 crm:gap-1 crm:transition-all"
}
const _hoisted_4 = { class: "crm:inline-block crm:mt-3 crm:text-center crm:text-xs" }
const _hoisted_5 = { class: "crm:inline-block" }
const _hoisted_6 = { class: "crm:text-zinc-500 crm:px-2" }
const _hoisted_7 = {
  key: 0,
  class: "crm:grid crm:grid-cols-4 crm:gap-1 crm:transition-all"
}
const _hoisted_8 = {
  height: "100",
  width: "100"
}
const _hoisted_9 = ["fill"]
const _hoisted_10 = { class: "crm:inline-block crm:mt-3 crm:text-center crm:text-xs" }

import * as svgList from "../../svg/svgs.js"
import {reactive} from "vue";
import {useDesignSystem} from "../../composable/useDesignSystem";


export default {
  __name: 'DesignSystem',
  setup(__props) {

const iconsSection = reactive({
  isShow: false
})

const colorPaletteSection = reactive({
  isShow: false
})

const {design_colors} = useDesignSystem()

return (_ctx, _cache) => {
  const _component_base_icon = _resolveComponent("base-icon")

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      class: _normalizeClass([[iconsSection.isShow ? 'crm:h-[80vh]' : ''], "crm:px-4 crm:relative crm:top-[-30px] crm:overflow-y-scroll crm:border-b crm:pb-4"])
    }, [
      _createElementVNode("section", null, [
        _createElementVNode("div", _hoisted_1, [
          _cache[4] || (_cache[4] = _createElementVNode("span", { class: "crm:inline-block crm:font-bold crm:text-2xl crm:px-2 crm:bg-clip-text crm:bg-gradient-to-r crm:from-[#8E2DE2] crm:to-[#4A00E0] crm:text-transparent" }, "Icons", -1 /* CACHED */)),
          _createElementVNode("p", _hoisted_2, [
            _cache[2] || (_cache[2] = _createTextVNode("Icone prelevate dal sito: ", -1 /* CACHED */)),
            _cache[3] || (_cache[3] = _createElementVNode("a", {
              target: "_blank",
              href: "https://www.streamlinehq.com/icons/streamline-mini-line",
              class: "crm:hover:underline"
            }, "Streamline", -1 /* CACHED */)),
            _createElementVNode("span", {
              class: "crm:inline-block crm:ml-6 crm:cursor-pointer",
              onClick: _cache[0] || (_cache[0] = _withModifiers($event => (iconsSection.isShow = !iconsSection.isShow), ["prevent"]))
            }, _toDisplayString(iconsSection.isShow ? 'Chiudi': 'Apri'), 1 /* TEXT */)
          ]),
          (iconsSection.isShow)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                (_openBlock(), _createElementBlock(_Fragment, null, _renderList(svgList, (icon, iconKey) => {
                  return _createElementVNode("div", {
                    key: iconKey,
                    class: "crm:bg-white crm:my-2 crm:flex crm:flex-col crm:justify-center crm:p-1"
                  }, [
                    _createVNode(_component_base_icon, {
                      icon: icon,
                      class: "crm:m-auto"
                    }, null, 8 /* PROPS */, ["icon"]),
                    _createElementVNode("span", _hoisted_4, _toDisplayString(iconKey), 1 /* TEXT */)
                  ])
                }), 64 /* STABLE_FRAGMENT */))
              ]))
            : _createCommentVNode("v-if", true)
        ])
      ])
    ], 2 /* CLASS */),
    _createElementVNode("div", {
      class: _normalizeClass([[colorPaletteSection.isShow ? 'crm:h-[80vh]' : ''], "crm:px-4 crm:relative crm:top-[-30px] crm:overflow-y-scroll crm:border-b crm:pb-4 crm:mt-4"])
    }, [
      _createElementVNode("section", null, [
        _createElementVNode("div", _hoisted_5, [
          _cache[6] || (_cache[6] = _createElementVNode("span", { class: "crm:inline-block crm:font-bold crm:text-2xl crm:px-2 crm:bg-clip-text crm:bg-gradient-to-r crm:from-[#8E2DE2] crm:to-[#4A00E0] crm:text-transparent" }, "Colors", -1 /* CACHED */)),
          _createElementVNode("p", _hoisted_6, [
            _cache[5] || (_cache[5] = _createTextVNode("CRM palette colori ", -1 /* CACHED */)),
            _createElementVNode("span", {
              class: "crm:inline-block crm:ml-6 crm:cursor-pointer",
              onClick: _cache[1] || (_cache[1] = _withModifiers($event => (colorPaletteSection.isShow = !colorPaletteSection.isShow), ["prevent"]))
            }, _toDisplayString(colorPaletteSection.isShow ? 'Chiudi': 'Apri'), 1 /* TEXT */)
          ]),
          (colorPaletteSection.isShow)
            ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(design_colors), (color, colorKey) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: colorKey,
                    class: "crm:bg-white crm:my-2 crm:flex crm:flex-col crm:items-center crm:justify-center crm:p-1"
                  }, [
                    (_openBlock(), _createElementBlock("svg", _hoisted_8, [
                      _createElementVNode("circle", {
                        cx: "50",
                        cy: "50",
                        r: "40",
                        stroke: "black",
                        "stroke-width": "2",
                        fill: color
                      }, null, 8 /* PROPS */, _hoisted_9)
                    ])),
                    _createElementVNode("span", _hoisted_10, _toDisplayString(colorKey), 1 /* TEXT */)
                  ]))
                }), 128 /* KEYED_FRAGMENT */))
              ]))
            : _createCommentVNode("v-if", true)
        ])
      ])
    ], 2 /* CLASS */)
  ], 64 /* STABLE_FRAGMENT */))
}
}

}